import React from "react";
import { Card, Tab, Tabs } from "react-bootstrap";
import { useIntl } from "react-intl";
import { useNavigate, useLocation } from "react-router-dom";

import SignalImages from "./SignalImages.jsx";
import SignalImagesExport from "./SignalImagesExport.jsx";

const messages = {
  title: {
    id: "modules.TrainStopSignalImages.components.Dashboard.signalImages",
    description: "Signal images title",
    defaultMessage: "Machinist - Signal images",
  },
  signalImages: {
    id: "modules.TrainStopSignalImages.components.Dashboard.tabSignalImages",
    description: "Signal images tab label",
    defaultMessage: "Signal images",
  },
};

const Dashboard = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const location = useLocation();

  const activeKey = location.hash || "#signal-images";

  const handleSelect = (key) => {
    navigate(key);
  };

  return (
    <Card>
      <Card.Header className="card-header-borderless" as="h3">
        {intl.formatMessage(messages.title)}
      </Card.Header>
      <Card.Body>
        <Tabs
          activeKey={activeKey}
          onSelect={handleSelect}
          id="signal-images-dashboard-tabs"
          className="custom-tabs"
        >
          <Tab
            eventKey="#signal-images"
            title={intl.formatMessage(messages.signalImages)}
          >
            <SignalImages />
          </Tab>
          <Tab eventKey="#export" title="Export">
            <SignalImagesExport />
          </Tab>
        </Tabs>
      </Card.Body>
    </Card>
  );
};

export default Dashboard;
